import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api, { fileUrl } from "@/lib/api";
import { formatDate } from "@/i18n";
import { Newspaper } from "lucide-react";

export default function NewsList() {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/news").then((r) => setNews(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="news-list-page" className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
      <div className="text-xs uppercase tracking-[0.3em] text-bordeaux-accent mb-4">{t("news.eyebrow")}</div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 mb-12">
        {t("news.title")}
      </h1>

      {loading ? (
        <div className="text-slate-500 text-sm">{t("common.loading")}</div>
      ) : news.length === 0 ? (
        <div className="border border-dashed border-slate-200 rounded-sm py-20 text-center text-slate-500">
          <Newspaper className="mx-auto mb-3" size={24} />
          {t("news.empty")}
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map((n) => (
            <Link
              key={n.id}
              to={`/news/${n.id}`}
              data-testid={`news-item-${n.id}`}
              className="group bg-white border border-slate-200 rounded-sm overflow-hidden hover:border-bordeaux transition-colors"
            >
              <div className="aspect-[4/3] bg-beige overflow-hidden">
                {n.image_path ? (
                  <img
                    src={fileUrl(n.image_path)}
                    alt={n.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <div className="w-full h-full grid place-items-center text-slate-400">
                    <Newspaper size={28} />
                  </div>
                )}
              </div>
              <div className="p-6">
                <div className="text-xs uppercase tracking-widest text-slate-500 mb-2">
                  {formatDate(n.publish_at)}
                </div>
                <h3 className="text-lg font-semibold text-slate-900 group-hover:text-bordeaux transition-colors leading-snug break-words">
                  {n.title}
                </h3>
                {n.excerpt && <p className="text-sm text-slate-600 mt-3 line-clamp-3 break-words">{n.excerpt}</p>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
